import { Input } from "reactstrap";

import RequiredTitle from "elements/RequiredTitle";

// Input group for acquiring details about the cloud.
const CloudNameGroup = ({ values, onChange }) => {
  return (
    <>
      <RequiredTitle title="Cloud Name" />
      <Input
        name="Name"
        value={values.Name}
        onChange={onChange}
        placeholder="Name"
      />
    </>
  );
};

export default CloudNameGroup;
